import { BaseApi } from './baseApi';
import { adaptListParams } from '../utils';
export default class SharedBookContactPermissionApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiPrefix = 'shared-book-permission/contact';
    }
    getSharedBookContactPermission(id) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiPrefix}/${id}`,
        });
    }
    listSharedBookContactPermission(params = {}) {
        return this.apiCall({
            method: 'GET',
            route: this.apiPrefix,
            params: Object.assign({}, adaptListParams(params)),
        });
    }
    updateSharedBookContactPermission(id, data) {
        return this.apiCall({
            method: 'PATCH',
            route: `${this.apiPrefix}/${id}`,
            data,
        });
    }
    deleteSharedBookContactPermission(id) {
        return this.apiCall({
            method: 'DELETE',
            route: `${this.apiPrefix}/${id}`,
        });
    }
    createSharedBookContactPermission(data) {
        return this.apiCall({
            method: 'POST',
            route: this.apiPrefix,
            data,
        });
    }
}
//# sourceMappingURL=sharedBookContactPermissionApi.js.map